export const chargeTypeOptions = [
    {
        label: '£',
        value: 'amount',
    },
    {
        label: '%',
        value: 'percent',
    },
];

export const strings = {
    investmentAmountAndCharges: 'Investment amount and charges',
    currencySymbol: '£',
    percentageSymbol: '%',
    investmentAmount: 'Investment amount',
    slAnnualManagementCharge: 'Standard Life annual management charge',
    slAnnualManagementChargeInfo:
        'Net annual management charge is 0.48% for investments over £25,000, 0.68% for less than £25,000*',
    initialAdviserCharge: 'Initial adviser charge',
    ongoingAdviserCharge: 'Ongoing adviser charge',
    helpMessageAdviserCharge: 'Please enter the agreed adviser charge. Enter 0% if no charge applies.',
};
